import React, { useState, useContext } from "react"
import { useOnScreen } from "@kit/design/use-on-screen"
import useFetch from "hooks/use-new-fetch"
import cx from "classnames"
import { DiscoveryHubContext } from "../discovery-hub-context"

import "./changelog-item.css"

export function ChangelogItem({
  id,
  title,
  description,
  publishedAt,
  link,
  isUnseen = true
}) {
  const [request] = useFetch(`/onboarding/changelog_items/${id}`)
  const changelogItemRef = React.useRef()
  const isOnScreen = useOnScreen(changelogItemRef)
  const [showPulse, setShowPulse] = useState(isUnseen)

  const context = useContext(DiscoveryHubContext)

  React.useEffect(() => {
    const fetchData = async () => {
      await request.put({ id: id })

      setTimeout(() => {
        setShowPulse(false)
      }, 400)
    }

    if (showPulse && isOnScreen) {
      context.decrementNotificationCounter()
      fetchData()
    }
  }, [isOnScreen]) // eslint-disable-line react-hooks/exhaustive-deps

  const statusClass = cx(
    `
      flex
      pb-5
      status
    `,
    {
      "is-visible": showPulse,
      "is-hidden": !showPulse
    }
  )

  return (
    <div className="border-b py-4 changelog-item">
      <h2 className="text-lg text-gray-900 pb-3">
        <a href={link} target="_blank" rel="noreferrer">
          {title}
        </a>
      </h2>

      <div className={statusClass}>
        <div className="pulse-container">
          <div className="pulse" ref={changelogItemRef}>
            <div className="pulse-dot pulse-dot--green"></div>
          </div>
        </div>

        <div className="published text-xs text-gray-700">{publishedAt}</div>
      </div>

      <div
        className="changelog-item-description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  )
}
